<template>
  <el-row class="file" :class="className">
    <el-row class="file-hd"
      ><em v-show="image._required" class="is-required mainColor">*</em>{{ image._title }}
      <span class="del-btn mainColor" @click="delImg">删除</span>
      <span class="per-btn mainColor" v-if="pdfShow" @click="perPdf">
        预览
        <!-- <img
          :src="image.image_url"
          alt=""
          style="
            width: 30px;
            height: 20px;
            position: absolute;
            top: 0;
            right: 0;
            opacity: 0;
          "
          @click="isshow = true"
        /> -->
      </span>
      <span class="per-btn" @click="perImg" v-else>预览</span>
    </el-row>
    <el-row class="file-bd relative" :class="{ noPadding: noPadding }" :style="{ width, height }">
      <el-upload drag class="upload" action="#" :show-file-list="false" :http-request="fnUploadRequest" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
        <pdf :src="image.image_url" v-if="image.image_url && pdfShow"></pdf>
        <img v-else-if="image.image_url && !pdfShow" :src="image.image_url" />
        <slot v-else-if="$slots.default"></slot>
        <i v-else class="iconfont icon-icon81"></i>
        <!-- <div slot="tip" class="el-upload__tip">{{image._title}} </div> -->
      </el-upload>
    </el-row>
    <template v-if="image._controlType">
      <el-row class="file-ft" v-if="image._controlType != 'date'">
        <el-input v-if="image._controlType == 'text'" placeholder="请输入描述" v-model="image.description"></el-input>
        <el-input v-if="image._controlType == 'more'" placeholder="请输入描述" v-model="image.description"></el-input>
      </el-row>
      <el-row class="file-ft" v-if="image._controlType == 'date' && showPickerDate">
        <span class="file-ft-label">有效期</span>
        <el-date-picker type="date" value-format="yyyy-MM-dd" :clearable="false" v-model="image.indate" placeholder="选择日期" :disabled="image._disabled"></el-date-picker>
        <i class="iconfont icon-icon1 unit"></i>
      </el-row>
    </template>
    <el-dialog center title="合同图片" :visible.sync="isshow" class="dialog-lg" :before-close="handleClose">
      <!-- <iframe :src="image.image_url" style="height: 100%; width: 100%"></iframe> -->
      <pdf style="height: 100%; width: 100%" :src="image.image_url"></pdf>
    </el-dialog>
  </el-row>
</template>

<script>
import pdf from 'vue-pdf'
import { isSuccess } from '@/assets/js/utils'
export default {
  data() {
    return {
      // image_type: null,
      // image_url: null,
      //indate: null
      // description: ''
      showImg: this.isShow,
      isshowImg: false,
      pdfShow: true,
      pdfImgList: [],
      isshow: false
    }
  },
  props: {
    image: {
      _title: '',
      _controlType: '',
      _required: false,
      _disabled: false,
      image_type: null,
      image_url: null,
      indate: null,
      description: '',
      showPdf: false,
      showImg: this.showImg
    },
    showPickerDate: {
      default: true
    },
    noPadding: {
      default: false
    },
    width: {
      default: undefined
    },
    height: {
      default: undefined
    },
    className: {
      default: ''
    }
  },
  created() {},
  components: {
    pdf
  },
  methods: {
    handleAvatarSuccess() {},
    delImg() {
      this.image.image_url = ''
      let json = {
        type: this.image.image_type,
        url: '',
        showPdf: this.image.showPdf
      }
      this.pdfShow = false
      this.$emit('getUrl', json)
    },
    handleClose() {
      this.isshow = false
    },
    perPdf() {
      this.pdfImgList = []
      this.parsePdfjsLib(this.image.image_url)
    },
    parsePdfjsLib(url) {
      if (!url) {
        return
      }

      this.pdfjsLib.getDocument(url).then((pdf) => {
        //调用pdf.js获取文件
        if (pdf) {
          const totalPages = pdf.numPages //获取pdf文件总页数
          //遍历动态创建canvas
          for (var i = 1; i <= totalPages; i++) {
            var canvas = document.createElement('canvas')
            canvas.id = 'pageNum' + i
            var context = canvas.getContext('2d')
            this.renderImg(pdf, i, context, totalPages)
          }
        }
      })
    },
    renderImg(pdfFile, pageNumber, canvasContext, totalPages) {
      pdfFile.getPage(pageNumber).then((page) => {
        //逐页解析PDF
        var viewport = page.getViewport(4) // 页面缩放比例
        var newcanvas = canvasContext.canvas

        //设置canvas真实宽高
        newcanvas.width = viewport.width
        newcanvas.height = viewport.height

        //设置canvas在浏览中宽高
        newcanvas.style.width = '100%'
        newcanvas.style.height = '100%'

        var renderContext = {
          canvasContext: canvasContext,
          viewport: viewport
        }

        page.render(renderContext).then(() => {
          const img = newcanvas.toDataURL('image/jpeg')
          this.$set(this.pdfImgList, pageNumber - 1, img)
          const len = this.pdfImgList.filter((item) => !!item).length
          if (len == totalPages) {
            this.$viewerApi({ images: this.pdfImgList })
          }
        }) //渲染生成
      })
    },

    perImg() {
      if (this.image.image_url) {
        this.$viewerApi({ images: [this.image.image_url] })
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const extension = file.name.split('.')[1] === 'pdf'
      const extension2 = file.name.split('.')[1] === 'PDF'
      if (!isJPG && !isPNG && !extension && !extension2) {
        this.$message.error('上传图片只能是 JPG/PNG/PDF 格式!')
      }
      return isJPG || isPNG || extension || extension2
    },
    async fnUploadRequest(option) {
      api('aliyun.sts.verify').then((res) => {
        let data
        if ((data = isSuccess(res))) {
          _global_.uploadIng.push(1)
          let OSS = require('ali-oss')
          let store = new OSS({
            region: data.aliyun_region,
            accessKeyId: data.access_key_id,
            accessKeySecret: data.access_key_secret,
            stsToken: data.security_token,
            bucket: data.aliyun_bucket
          })
          let random_name = this.image.image_type.toLowerCase() + '/' + this.guid() + '.' + option.file.name.split('.').pop()
          store.put(random_name, option.file).then((res) => {
            // this.image.image_url = res.url.replace(/static-5j56-com.oss-cn-shanghai.aliyuncs.com/, "static.5j56.com")
            let arrPDF = []
            if (this.image.image_url.indexOf('.pdf') !== -1) {
              this.image.showPdf = true
              arrPDF = res.url.split('://')
              this.image.image_url = 'https://' + arrPDF[1]
            } else {
              this.image.image_url = res.url
              this.image.showPdf = false
            }
            let json = {
              type: this.image.image_type,
              url: this.image.image_url,
              showPdf: this.image.showPdf
            }
            _global_.uploadIng.splice(0, 1)
            this.$emit('getUrl', json)
          })
        }
      })
    },
    guid() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import 'src/assets/sass/mixin';
.yu-img {
  width: 30px;
  height: 20px;
  position: absolute;
  top: 0;
  opacity: 0;
}
.del-btn {
  position: absolute;
  right: 0%;
  cursor: pointer;
  font-size: 12px;
  line-height: 24px;
  bottom: 2px;
}
.per-btn {
  position: absolute;
  cursor: pointer;
  right: 20%;
  font-size: 12px;
  line-height: 24px;
  bottom: 2px;
}
.noPadding {
  padding: 0;
  border: 0;
  .upload {
    border: 0;
  }
}
.relative {
  position: relative;
}
.column-bd {
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/upload/upload-file-pdf.vue